import type { LexCounselSlashCommand } from './lexCounselCommands';

export type LexCounselSendScope = 'document' | 'paragraph' | 'selection';
export type LexCounselSendSource = 'inline' | 'panel' | 'slash' | 'selection';

export type LexCounselSendDetail = {
  text: string;
  scope?: LexCounselSendScope;
  commandId?: string;
  command?: LexCounselSlashCommand;
  source?: LexCounselSendSource;
};

export function dispatchLexCounselSend(detail: LexCounselSendDetail): void {
  window.dispatchEvent(new CustomEvent('lexcounsel-send', { detail }));
}

export function dispatchLexCounselStop(): void {
  window.dispatchEvent(new CustomEvent('lexcounsel-stop'));
}
